module.exports = __webpack_public_path__ + "static/media/4.36b44fa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/03/projects/01/4.jpg
// module id = 411
// module chunks = 0